;(function (Handlebars, window) {
    // Uses same syntax as #if helper but initially returns false for falsey || empty string values.
    Handlebars.registerHelper('unless_blank', function(item, options) {
        return (item && item.replace(/\s/g,"").length) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper("math", function (lvalue, operator, rvalue) {
        lvalue = parseFloat(lvalue);
        rvalue = parseFloat(rvalue);

        return {
            "+": lvalue + rvalue,
            "-": lvalue - rvalue,
            "*": lvalue * rvalue,
            "/": lvalue / rvalue,
            "%": lvalue % rvalue
        }[operator];
    });
    Handlebars.registerHelper('currency', function(price, options) {
        var isCents = (typeof options.hash.isCents == 'undefined')?true:options.hash.isCents;
        if (isCents) {
            price = price / 100;
        }
        var dplaces = price == parseInt(price, 10) ? 0 : 2;
        return price.toFixed(dplaces);
    });

    Handlebars.registerHelper("is", function () {
        var args = arguments
            , left = args[0]
            , operator = args[1]
            , right = args[2]
            , options = args[3];


        var isArray = function(value) {
            return Object.prototype.toString.call(value) === '[object Array]';
        }
        var isIn = function(need, array) {
            if ( ! isArray(array)) {
                array = array.split(',');
            }
            return array.indexOf(need) !== -1;
        };

        if (args.length == 3) {
            right = args[1];
            options = args[2];
            operator = "=="
        }

        return {
            "==": function(){return (left == right)},
            "!=": function(){return (left != right)},
            "===": function(){return (left === right)},
            "!==": function(){return (left !== right)},
            ">": function(){return (left > right)},
            ">=": function(){return (left >= right)},
            "<": function(){return (left < right)},
            "<=": function(){return (left <= right)},
            "in": function(){return isIn(left, right)},
        }[operator]()?options.fn(this):options.inverse(this);
    });

    var STATE_ONLINE            = 1;
    var STATE_OFFLINE           = 2;
    var STATE_CANCEL_REFUND     = 3;
    var STATE_CANCEL_NO_REFUND  = 4;
    var STATE_DEFER_REFUND      = 5;
    var STATE_DEFER_NO_REFUND   = 6;
    var STATE_CANCEL            = 7;
    var STATE_COMPLETE          = 8;
    var STATE_SOON              = 9;
    var STATE_END               = 10;
    var STATE_AVAILABLE         = 11;
    Handlebars.registerHelper('isBookable', function(state, options) {
        return (state == STATE_ONLINE || state == STATE_AVAILABLE) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('isClosed', function(state, options) {
        return (state == STATE_OFFLINE || state == STATE_END) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('isCancelled', function(state, options) {
        return (state == STATE_CANCEL_REFUND || state == STATE_CANCEL_NO_REFUND || state == STATE_CANCEL) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('isDeferred', function(state, options) {
        return (state == STATE_DEFER_REFUND || state == STATE_DEFER_NO_REFUND) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('isFull', function(state, options) {
        return (state == STATE_COMPLETE) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('isSoon', function(state, options) {
        return (state == STATE_SOON) ? options.fn(this) : options.inverse(this);
    });
    Handlebars.registerHelper('showPrice', function(state, options) {
        return (state == STATE_ONLINE || state == STATE_AVAILABLE || state == STATE_SOON) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('toLowerCase', function (str) {
        return (str + '').toLowerCase();
    });
    Handlebars.registerHelper('toUpperCase', function (str) {
        return (str + '').toUpperCase();
    });
    Handlebars.registerHelper('capitalize', function (str) {
        str = str || '';
        return (str + '').charAt(0).toUpperCase() + str.slice(1);
    });
    Handlebars.registerHelper('ucwords', function (str) {
        str = str || '';
        return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
            return $1.toUpperCase();
        });
    });
    Handlebars.registerHelper('for', function (from, to, incr, block) {
        var out = '';
        var i;
        var data = {};
        if (to) {
            for (i = from; i < to; i += incr) {
                data.index = i;
                out += block.fn(this, {
                    data: data
                });
            }
        } else {
            out = opts.inverse(this);
        }
        return out;
    });
    //  format an ISO date using Moment.js
    //  http://momentjs.com/
    //  moment syntax example: moment(Date("2011-07-18T15:50:52")).format("MMMM YYYY")
    //  usage: {{dateFormat creation_date format="MMMM YYYY"}}
    Handlebars.registerHelper('dateFormat', function(datetime, options) {
        if (window.moment) {
            var f = options.hash.format || "MMM Do, YYYY";
            return moment(datetime).format(f);
        }else{
            return context;   //  moment plugin not available. return data as is.
        };
    });

    Handlebars.registerHelper("formatDateRange", function(dateStart, dateEnd, format) {
        var DateFormats = {
            'fr': {
                short: {
                    from: "[À partir du] D MMM YYYY",
                    until: "[Jusqu'au] D MMM YYYY",
                    day: "dddd D MMM YYYY",
                    period: ["[Du] D MMMM YYYY ", "[au] D MMMM YYYY"],
                    periodSameYear: ["[Du] D MMMM ", "[au] D MMMM YYYY"]
                },
                long: {
                    from: "[À partir du] D MMM YYYY",
                    until: "[Jusqu'au] D MMM YYYY",
                    day: "dddd D MMMM YYYY",
                    period: ["[Du] D MMMM YYYY ", "[au] D MMMM YYYY"],
                    periodSameYear: ["[Du] D MMMM ", "[au] D MMMM YYYY"]
                }
            },
            'en': {
                short: {
                    from: "[From] D MMM YYYY",
                    until: "[Until] D MMM YYYY",
                    day: "dddd D MMM YYYY",
                    period: ["[From] D MMMM YYYY ", "[to] D MMMM YYYY"],
                    periodSameYear: ["[From] D MMMM ", "[to] D MMMM YYYY"]
                },
                long: {
                    from: "[From] D MMM YYYY",
                    until: "[Until] D MMM YYYY",
                    day: "dddd D MMMM YYYY",
                    period: ["[From] D MMMM YYYY ", "[to] D MMMM YYYY"],
                    periodSameYear: ["[From] D MMMM ", "[to] D MMMM YYYY"]
                }
            },
            'es': {
                short: {
                    from: "[Desde] D MMM YYYY",
                    until: "[Hasta el] D MMM YYYY",
                    day: "dddd D MMM YYYY",
                    period: ["[Desde] D MMMM YYYY ", "[hasta] D MMMM YYYY"],
                    periodSameYear: ["[Desde] D MMMM ", "[hasta] D MMMM YYYY"]
                },
                long: {
                    from: "[Desde] D MMM YYYY",
                    until: "[Hasta el] D MMM YYYY",
                    day: "dddd D MMMM YYYY",
                    period: ["[Desde] D MMMM YYYY ", "[hasta] D MMMM YYYY"],
                    periodSameYear: ["[Desde] D MMMM ", "[hasta] D MMMM YYYY"]
                }
            }
        };
        if (moment) {

            var locale = moment.locale();
            if(typeof DateFormats[locale] === 'undefined'){
                locale = 'fr';
            }
            if(typeof format == undefined){ var format = 'short'; }

            var config = DateFormats[locale][format];
            if(dateStart && !dateEnd){
                return moment(dateStart).format(config.from);
            }
            else if(!dateStart && dateEnd){
                return moment(dateEnd).format(config.until);
            }
            else if(dateStart && dateEnd){
                if(moment(dateStart).format("DDMMYYYY") == moment(dateEnd).format("DDMMYYYY") || moment(dateEnd).format("X") - moment(dateStart).format("X") < 86400){
                    return moment(dateStart).format(config.day);
                }
                else{
                    if(moment(dateStart).format("YYYY") == moment(dateEnd).format("YYYY")){
                        return moment(dateStart).format(config.periodSameYear[0])+moment(dateEnd).format(config.periodSameYear[1]);
                    }else{
                        return moment(dateStart).format(config.period[0])+moment(dateEnd).format(config.period[1]);
                    }
                }
            }


        }
        return dateStart+dateEnd;
    });
})(Handlebars, window);
